var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgshape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bgshape.svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 980.59,
    viewBox: "0 0 1920 980.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1 {\n        opacity: 0.05;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.03;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M874,6865S517.3,7233.22,0,7079V6863Z",
    transform: "translate(0 -6863)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620,6865S427.381,7046.98-4,7006V6864Z",
    transform: "translate(0 -6863)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1921,7196c-122.03,143.78-350.43,490.07-599,520S383.6,7430.83,132,7842.7H1920S1925.01,7372.79,1921,7196Z",
    transform: "translate(0 -6863)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1920,7524c-162.71,129.95-317.7,302.01-643,241-430.631-80.77-846.3-169.62-1028,78.61L1920,7840S1920.51,7640.79,1920,7524Z",
    transform: "translate(0 -6863)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgshape);
export default __webpack_public_path__ + "static/media/bgshape.b34ca3ae0aaf1a6c98590def5fdd620a.svg";
export { ForwardRef as ReactComponent };